import React from "react";
import { Flex } from "@chakra-ui/react";
import { AccordionItem } from "components";
import {
  Authorizations,
  ClientInformation,
  Disclaimers,
  DropOff,
  PatientInformation
} from "./components";

const CheckIn: React.FC = () => {
  return (
    <Flex mt={6} direction="column" gap={6}>
      <AccordionItem title="Patient and Client Information">
        <PatientInformation />
        <ClientInformation />
      </AccordionItem>

      <AccordionItem title="Authorizations">
        <Authorizations />
      </AccordionItem>

      <AccordionItem title="Drop-Off" defaultExpanded={false}>
        <DropOff />
      </AccordionItem>

      <AccordionItem title="Disclaimers">
        <Disclaimers />
      </AccordionItem>
    </Flex>
  );
};

export default React.memo(CheckIn);
